import { MutationTree } from "vuex";
import { IServiceProviderState, getDefaultSPState } from ".";
import { IServiceProvider } from "@/models/serviceprovider";

export const mutations: MutationTree<IServiceProviderState> = {
    setServiceProviders(state, payload: IServiceProvider[]) {
        state.error = null;
        state.serviceProvidersList = [...payload];
    },
    setSelectedServiceProvider(state, payload: IServiceProvider) {
        state.isSelectedServiceProvider = !!payload;
        state.selectedServiceProvider = payload;
    },
    serviceProvidersError(state, payload: any) {
        state.error = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultSPState());
    },
};
